// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1i148","options":"AnswerScale_options__2LaYy","selected":"AnswerScale_selected__sKCrN"};